import {Button, Container, FloatingLabel, Form, Modal} from "react-bootstrap";
import React, {useState} from "react";
import {showSuccessToast} from "../utils/usacmUtils";
import {regFieldSync} from "../api/AdminApi";
import {fieldHasErrors, getErrorMessageForField} from "../utils/formUtils";
import {downloadFile} from "../utils/networkUtils";
import {deleteFieldsAndActions} from "../api/RegApi";

const SYNC_MODE_ADD = 'add';
const SYNC_MODE_UPDATE = 'update';

export function ToolsRegFields() {
  const [regId, setRegId] = useState('');
  const [errors, setErrors] = useState([]);
  const [showingDeleteConfirm, setShowingDeleteConfirm] = useState(false);

  function callRegFieldSync(mode) {
    setErrors([]);
    regFieldSync(regId, mode, (code, data, errors) => {
      if (code === 200) {
        if (mode === SYNC_MODE_ADD) {
          if (data['fields_added']?.length > 0) {
            const fieldNames = data['fields_added'].map(f => f.name).join(', ');
            showSuccessToast('Missing reg fields have been added : ' + fieldNames);
          } else {
            showSuccessToast('No missing fields found');
          }
        } else if (mode === SYNC_MODE_UPDATE) {
          if (data['fields_updated']?.length > 0) {
            const fieldNames = data['fields_updated'].map(f => f.name).join(', ');
            showSuccessToast('Updated reg fields : ' + fieldNames);
          } else {
            showSuccessToast('No reg fields need updating.');
          }
        }
      } else {
        setErrors(errors);
      }
    });
  }

  function callDeleteFieldsAndActions() {
    deleteFieldsAndActions((code, data, errors) => {
      if (code === 200) {
        showSuccessToast('Deleted fields and actions');
        setShowingDeleteConfirm(false);
      } else {
        setErrors(errors);
      }
    });
  }

  return (
    <Container fluid className="usacm-container-medium">
      <div className='border border-1 mt-3 p-3'>
        <div className='fw-bold text-center'>
          Reg Fields and Actions
        </div>
        <div className='mt-3'><b>Export Fields and Actions</b> Can be used to copy all the fields and actions from one conf into another.
          The confs can be on different servers, which will allow copying fields and actions from an archived conf or from the previous
          state of a conf.
        </div>
        <div className='mt-3'><b>Delete All Fields and Actions</b> This will delete ALL the fields and actions in this conf. If there are
          existing reg then the fields will be flagged as deleted, if there are no reg the fields we be really deleted.
        </div>
        <div className='mt-3 usacm-button-row'>
          <Button variant="primary" onClick={() => downloadFile('reg/fields-and-actions/export/', 'field_export.json')}>
            Export Fields and Actions
          </Button>
          <Button variant="danger" onClick={() => setShowingDeleteConfirm(true)}>Delete All Fields and Actions</Button>
        </div>
      </div>

      <div className='border border-1 mt-3 p-3'>
        <div className='fw-bold text-center'>
          Sync Reg Fields
        </div>
        <div className='mt-3'>
          When registration fields or sections are added any reg that has already been created will be missing the new fields and their
          settings.
        </div>
        <div className='mt-3'>
          <b>Create Missing Reg Fields</b> : Will create fields in the reg to match the current field list.
        </div>
        <div className='mt-3'>
          <b>Update Reg Fields</b> : Will update all the fields in the reg to match the current field settings. This will add missing
          choicelist options, as well as field-type specific settings like : "Show as Radio", "Show Other", "Long Text", "Min", "Max" etc.
        </div>

        <div className='mt-3 d-flex align-items-center'>
          <Form.Group controlId="reg-id">
            <FloatingLabel controlId="reg-id" label="Reg ID">
              <Form.Control
                type="number"
                placeholder="Reg ID"
                name="reg_id"
                value={regId}
                onChange={e => setRegId(e.target.value)}
                isInvalid={fieldHasErrors(errors, '')}
              />
              <Form.Control.Feedback type="invalid">
                {getErrorMessageForField(errors, '')}
              </Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>
          <div className='ms-3 usacm-button-row'>
            <Button type="button" onClick={() => callRegFieldSync(SYNC_MODE_ADD)}>Create Missing Reg Fields</Button>
            <Button type="button" onClick={() => callRegFieldSync(SYNC_MODE_UPDATE)}>Update Reg Fields</Button>
          </div>
        </div>
      </div>

      <Modal show={showingDeleteConfirm}
             onHide={() => setShowingDeleteConfirm(false)}
             size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete All Fields and Actions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='mt-3'>
            Are you sure you want to delete all fields and actions? If you have reg existing this will flag the fields as deleted, as they
            cannot be deleted due to referential integrity constraints. If there are no reg this will do an actual delete and cannot be
            undone. Actions will be deleted whether reg exist or not, but the new actions created may not work with old reg (which only
            matters if you edit the fields of an old reg).
          </div>
          <div className='mt-3'>
            If you delete all the fields and actions with existing reg, the reg will still be linked to the deleted fields and even
            if you re-create a field with the same name it will not be considered as the same field, so some things may not work properly
            with the old regs like "show in summary", "show on invoice", and actions using the new field.
          </div>
          {fieldHasErrors(errors, 'delete') &&
            <div className="mt-3 text-center mb-3 usacm-error-message">
              {getErrorMessageForField(errors, 'delete')}
            </div>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowingDeleteConfirm(false)}>Cancel</Button>
          <Button variant="danger" onClick={() => callDeleteFieldsAndActions()}>Delete All Fields and Actions</Button>
        </Modal.Footer>
      </Modal>

    </Container>
  );
}
